module.exports = __webpack_public_path__ + "static/19.4-c189cce37af801076ed9b946bfa9a8ce.jpg";